import { IDSK, Replace, Student } from "@examspark/types";

import { GraphQLAPI } from "../../client";

export const getClassroomStudent = async (
  params: Replace<IDSK, { sk: `student#${string}` }>,
) => {
  return (
    (
      await GraphQLAPI.client.query<{ getStudent: Student }>({
        query: /* GraphQL */ `
          query GetClassroomStudent($input: ModelGetInput!) {
            getStudent(input: $input) {
              id
              sk
              studentId
              firstName
              lastName
              fullName
              workspaceId
            }
          }
        `,
        variables: {
          input: {
            id: params.id,
            sk: params.sk,
          },
        },
        authMode: "API_KEY",
      })
    ).data?.getStudent ?? null
  );
};
